const sli = targetedActions => store => {
  /**
   * This middleware modifies response payloads so that there is necessary data available for SLI (Service Level Indicators) instrumentation
   */
  return next => {
    return async action => {
      if (targetedActions.includes(action.type)) {
        const { user } = store.getState();
        const { payload } = action;
        const updatedPayload = {
          ...payload,
          userId: user?._id
        };
        return next({
          ...action,
          payload: updatedPayload
        });
      }
      return next(action);
    };
  };
};

export default sli;
